import { graphql } from '@graphql/gql';

export const ME = graphql(`
  query ME($locale: String!, $platform: String!, $sessionCriteria: SearchSessionCriteria) {
    me {
      id
      contactId
      virtual
      firstName
      lastName
      email
      guest
      confirmationNumber
      profileUrl
      profilePicture
      doNotSell
      prefix
      designation
      title
      company
      headline
      bio
      pronouns
      address(locale: $locale) {
        city
        region
        regionCode
        country
        countryCode
      }
      professionalInterests @appFeature(feature: "attendeeInterests") {
        id
        text
        commonInterest
      }
      facebookUrl
      twitterUrl
      linkedInUrl
      websiteUrl
      type {
        id
        name
        code
      }
      admissionItem {
        id
        name
        attendeeCanUpgradeAdmissionItem
      }
      attendeeHasChannels {
        hasChannels
        status
        limit
        remaining
        resetAt
      }
      visibility
      allowPushNotifications
      allowAppointmentPushNotifications
      permissions {
        isGlobalModerator
        sessionsToModerate
        roles {
          audienceEngagement
          videoHost
          speakerRoom
          boothStaff
        }
      }
      consent {
        hasAccepted
        id
        title
        terms
      }
      answers {
        questionId
        filterName
        filterOrder
        value
      }
      exhibitorConsentQuestion(locale: $locale) {
        id
        title
        questionText
        optInId
        optInText
        optOutId
        optOutText
      }
      exhibitorConsentAnswer {
        attendeeId
        questionId
        questionText
        answerId
        choice {
          text
          id
        }
        locale
        lastModifiedDate
      }
      preferences @appFeature(feature: "profileOnboarding") {
        id
        preferenceType
        preferenceValue
      }
      event {
        id
        cultureCode
        title
        timezone
        timezoneId
        defaultLocale
        currency
        start
        end
        status
        cventPrivacyPolicyText
        showCookieBanner
        showCookieBannerPrivacyPolicyLink
        showNonEssentialCookieBanner
        format
        gameInfo {
          id
          name
          validStart
          validEnd
        }
        venues {
          name
          address {
            address1
            address2
            address3
            city
            region
            regionCode
            postalCode
            country
            countryCode
          }
        }
        phone
        links {
          summary
          registration
          surveys
          privacyPolicy {
            url
            text
          }
          appointment
          ccpa
        }
        ccpaData @appFeature(feature: "showCcpaModalEnabled") {
          ccpaExternalDoNotSellUrl
          ccpaButtonText
          ccpaConfirmationText
          ccpaExplanationText
          ccpaInviteeValidationText
          ccpaLinkText
          showCcpaSectionFlag
          showCCPA
        }
        features {
          exhibitorManagement
          showExhibitorList
          sessionQA
          sponsors
          showSponsorList
          exhibitorsPresent
          gamePresent
          livePolling
          sessions
          onDemandCatalog
          registration
          sessionRecommendations
          speakers
          floorPlans
        }
        appointmentEvents {
          id
          apptEventCode
          status
          readOnly
          apptEventType
        }
        appConfig {
          appConfigString
          webConfig {
            headerImage
            coverImage
            coverImageAltText
            secondaryHeaderImage
            secondaryHeaderImageAltText
            sessionHeaderImage
            sessionHeaderImageAltText
            defaultProfileVisibility
            manageProfileEnabled
            footerImage
            footerImageAltText
            loginBackgroundImage
            loginBackgroundImageAltText
          }
        }
        accountConfig {
          faviconUrl
          hideCventFooter
        }
        resourceOverrides(locale: $locale, platform: $platform) {
          locale
          overrides {
            key
            value
          }
        }
        customFields {
          id
          name
          value
          type
        }
        liveAndUpcoming(sessionCriteria: $sessionCriteria) {
          id
          name
          code
          start
          end
          description
          enrolled
          featured
          openForRegistration
          openForAttendeeHub
          virtual
          included
          recommended
          capacity @appFeature(feature: "sessionCapacity") {
            active
            availableCapacity
            totalCapacityAvailable
          }
          fee @appFeature(feature: "sessionFee") {
            amount
          }
          category {
            id
            name
            code
          }
          location {
            id
            name
            code
          }
          webcast {
            id
            eventId
            sessionId
            format
            playerType
            player {
              id
              videoId
              stream {
                id
                status
              }
              duration
              simuliveOffset
            }
          }
          exhibitors {
            id
            name
            profileLogoUrl
          }
          sessionTags
        }
        codeSnippets {
          id
          dataTagCode
          codeSnippetValue
          applicableOn
          canDisableCodeSnippet
          category
        }
        supportedEventLocales {
          localeId
          languageName
          languageCountry
          isDefault
          cultureCode
        }
        eventTheme {
          logoImage
          logoImageOptimized
        }
      }
    }
  }
`);
